// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"b679a9a2","330":"00fea86a","430":"50082068","741":"2fcf4926","769":"0750558b","796":"b9fae171"}[chunkId] + ".chunk.css";
};